import { Controller } from "@hotwired/stimulus"

/**
 * Controller for dynamically loading scope options based on scope type
 * 
 * Usage:
 * <div data-controller="scope-options" data-scope-options-url-value="/admin/role_assignments/scope_options">
 *   <select data-scope-options-target="scopeType" data-action="change->scope-options#loadOptions">
 *   <select data-scope-options-target="scopeId">
 * </div>
 */
export default class extends Controller {
  static targets = ["scopeType", "scopeId", "scopeIdField"]
  static values = { url: String }

  connect() {
    // Set initial state
    if (this.scopeTypeTarget.value === '') {
      this.hideScopeIdField()
    }
  }

  loadOptions() {
    const scopeType = this.scopeTypeTarget.value

    if (scopeType === '') {
      this.hideScopeIdField()
      return
    }

    this.showScopeIdField()
    this.scopeIdTarget.innerHTML = '<option>Loading...</option>'
    this.scopeIdTarget.disabled = true

    fetch(`${this.urlValue}?scope_type=${encodeURIComponent(scopeType)}`, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.json())
      .then(data => {
        this.scopeIdTarget.innerHTML = '<option value="">Select...</option>'
        data.options.forEach(option => {
          const optionElement = document.createElement('option')
          optionElement.value = option.id
          optionElement.textContent = option.name
          this.scopeIdTarget.appendChild(optionElement)
        })
        this.scopeIdTarget.disabled = false
      })
      .catch(error => {
        console.error('Error loading scope options:', error)
        this.scopeIdTarget.innerHTML = '<option value="">Error loading options</option>'
        this.scopeIdTarget.disabled = false
      })
  }

  showScopeIdField() {
    if (this.hasScopeIdFieldTarget) {
      this.scopeIdFieldTarget.style.display = 'block'
    }
  }

  hideScopeIdField() {
    if (this.hasScopeIdFieldTarget) {
      this.scopeIdFieldTarget.style.display = 'none'
    }
    if (this.hasScopeIdTarget) {
      this.scopeIdTarget.value = ''
      this.scopeIdTarget.innerHTML = ''
    }
  }
}

